import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_list` layout match on bare `/dev-resources/errors`; it renders nothing.
export const Route = createFileRoute('/_app/dev-resources/errors/_list/')({})
